import { AppShell, Header } from '@mantine/core';
import HeaderContents from './components/header';
import Main from './pages';
import DescriptionList from './pages/description';

function App({ embed = false }: { embed?: boolean }) {
  return (
    <AppShell
      header={
        embed ? undefined : (
          <Header height={60} sx={{ borderBottom: 'none' }}>
            <HeaderContents />
          </Header>
        )
      }
      styles={{
        main: {
          'paddingLeft': 8,
          'paddingRight': 8,
          'paddingTop': embed ? 12 : undefined,
          'paddingBottom': 16,
          '@media (min-width: 640px)': {
            paddingLeft: 16,
            paddingRight: 16,
            paddingTop: embed ? 16 : undefined,
            paddingBottom: 24,
          },
        },
      }}
    >
      <Main />
      <DescriptionList />
    </AppShell>
  );
}

export default App;
